import { browser } from '$app/env';
import { goto } from '$app/navigation';
import posthog from 'posthog-js';
import { clearUserStores, pb } from './ApiClient';

export function logout() {
	clearUserStores();
	pb.authStore.clear();
	posthog.reset();
	browser ? goto('/') : '';
}
